import { Component, Input } from '@angular/core';

@Component({
  selector: 'ca-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss'],
  standalone: false,
})
export class CaInfoCardComponent {
  @Input()
  title: string;

  @Input()
  helpUrl?: string;
}
